import { useRemoteData } from "@sinch/mfe-helper-react";
import { apiUrls, formatters } from "..";
import { safeRetrieveValue } from "../../helpers/safeRetrieveValue";
import { useFetchUser } from "./useUser";

export const usePartner = () => {
  const [user] = useFetchUser();
  const businessId = safeRetrieveValue(
    user?.settings || {},
    "businessId",
    (x): x is string | null => x === null || typeof x === "string"
  );

  const partnerRemoteData = useRemoteData(
    `${apiUrls.partnerUrl}/${businessId}`,
    {
      enabled: !!businessId,
      parse: formatters.toShellPartner,
    }
  );

  return partnerRemoteData.mapResult({
    onInit: () => ({
      status: "init" as const,
    }),
    onLoading: () => ({
      isFetching: !!businessId,
      status: "loading" as const,
    }),
    onData: (data) => ({
      data,
      status: "success" as const,
    }),
    onError: (e) => ({
      e,
      status: "error" as const,
    }),
  });
};
